import React, { useState } from 'react';
import { Box, Fab, Badge, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { ShoppingCart as CartIcon } from '@mui/icons-material';
import { ProductSearch } from './ProductSearch';
import { CartPanel } from './CartPanel';
import { PaymentDialog } from './PaymentDialog';
import { usePosCart } from '../hooks/usePosCart';

export const PosRetailPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [cartOpen, setCartOpen] = useState(false);
  const { items } = usePosCart();

  if (!isMobile) {
    return (
      <>
        <Box sx={{ display: 'flex', height: '100%' }}>
          <Box sx={{ flex: '1 1 65%', display: 'flex', flexDirection: 'column', p: 1, overflow: 'hidden' }}>
            <ProductSearch />
          </Box>
          <Box sx={{ flex: '1 1 35%', borderLeft: 1, borderColor: 'divider', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <CartPanel />
          </Box>
        </Box>
        <PaymentDialog />
      </>
    );
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 1, overflow: 'hidden' }}>
        <ProductSearch />
      </Box>

      {/* FAB to open cart */}
      <Fab
        color="primary"
        onClick={() => setCartOpen(true)}
        sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1200 }}
      >
        <Badge badgeContent={items.length} color="error" overlap="circular">
          <CartIcon />
        </Badge>
      </Fab>

      {/* Cart Drawer */}
      <Drawer
        anchor="bottom"
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        PaperProps={{
          sx: { height: '85vh', borderTopLeftRadius: 16, borderTopRightRadius: 16 },
        }}
      >
        <Box
          sx={{ width: 40, height: 4, bgcolor: 'grey.400', borderRadius: 2, mx: 'auto', mt: 1, mb: 0.5 }}
          onClick={() => setCartOpen(false)}
        />
        <CartPanel onCheckout={() => setCartOpen(false)} />
      </Drawer>

      <PaymentDialog />
    </>
  );
};

export default PosRetailPage;
